import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

const faqs = [
  { q: "New Coupling은 어떤 서비스인가요?", a: "New Coupling은 40~60대 글로벌 한인 싱글을 위한 프리미엄 매칭 플랫폼입니다. 커뮤니티, AI 매칭, 전문 상담, 줌데이트 등 다양한 서비스를 제공합니다." },
  { q: "회원가입은 무료인가요?", a: "네, 기본 회원가입은 무료입니다. 무료 회원도 커뮤니티 게시판 이용, 연애사관학교 일부 콘텐츠 열람이 가능합니다. 정회원(Regular) 이상 업그레이드 시 AI 매칭, 메시지, 줌데이트 등 프리미엄 기능을 이용할 수 있습니다." },
  { q: "정회원 가입 비용은 얼마인가요?", a: "정회원(Regular)은 월 USD $29.99, 프리미엄(Premium)은 월 USD $49.99, VIP는 월 USD $99.99입니다. 연간 결제 시 2개월 무료 혜택이 있습니다." },
  { q: "혼인관계증명서는 왜 필요한가요?", a: "모든 회원의 싱글 여부를 확인하여 안전하고 신뢰할 수 있는 매칭 환경을 보장하기 위함입니다. 업로드된 서류는 암호화 저장되며, 심사 완료 후 원본은 즉시 삭제됩니다." },
  { q: "3:3 줌데이트는 어떻게 진행되나요?", a: "남녀 각 3명이 참여하여 30분씩 3회 1:1 로테이션 대화를 합니다. 전문 MC가 진행하며, 이벤트 후 매칭 서비스가 제공됩니다. 참가비는 이벤트별로 상이합니다." },
  { q: "AI 매칭은 어떤 원리인가요?", a: "회원님의 자기소개서, 성격, 가치관, 관심사 등을 AI가 분석하여 결이 맞는 이성을 추천합니다. 커뮤니티 글 작성 후 자동으로 추천이 이루어집니다." },
  { q: "포인트는 어떻게 적립하나요?", a: "프로필 사진 업로드(5,000P), 혼인관계증명서 인증(10,000P), 게시글 작성(3P), 댓글(1P), 친구 초대(500P) 등 다양한 활동으로 적립됩니다." },
  { q: "환불 정책은 어떻게 되나요?", a: "결제 후 7일 이내 서비스 미이용 시 전액 환불이 가능합니다. 고객센터로 문의해주세요." },
  { q: "해외 거주자도 가입할 수 있나요?", a: "네! New Coupling은 글로벌 한인을 위한 서비스입니다. 캐나다, 미국, 호주, 일본 등 전 세계 한인분들이 이용하고 계십니다." },
  { q: "개인정보는 안전한가요?", a: "모든 민감 서류는 AES 암호화로 저장되며, SSL/TLS를 통해 통신이 보호됩니다. 서류 심사 완료 후 원본 파일은 즉시 삭제됩니다." },
];

export default function FAQPage() {
  const [openIdx, setOpenIdx] = useState(null);
  return (
    <div className="min-h-screen bg-stone-50 pt-24 pb-16">
      <div className="max-w-3xl mx-auto px-6">
        <h1 className="text-3xl font-bold text-stone-800 mb-2">자주 묻는 질문</h1>
        <p className="text-stone-500 mb-8">궁금한 점이 있으시면 아래에서 확인해보세요.</p>
        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-white rounded-xl border border-stone-200 overflow-hidden">
              <button
                onClick={() => setOpenIdx(openIdx === i ? null : i)}
                className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-stone-50 transition-colors"
              >
                <span className="text-sm font-medium text-stone-800 pr-4">{faq.q}</span>
                {openIdx === i ? <ChevronUp className="w-4 h-4 text-stone-400 flex-shrink-0" /> : <ChevronDown className="w-4 h-4 text-stone-400 flex-shrink-0" />}
              </button>
              {openIdx === i && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-stone-600 leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
